<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForTask">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.establishTask")' :click="buttonClick" operate='add'></e-item>
        <e-item type='Separator'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Pm.activeTask")' :click="buttonClick" operate='active'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Pm.hangUpTask")' :click="buttonClick" operate='hungUp'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Pm.modifyTask")' :click="buttonClick" operate='modify'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.delTask")' :click="buttonClick" operate='delete'></e-item>
        <e-item type='Separator'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-task-tracking' :tooltipText='$t("Pm.checkUniformity")' :click="buttonClick" operate='consistency'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-sync-download' :tooltipText='$t("Pm.synchronousDownload")' :click="buttonClick" operate='sync'></e-item>
        <e-item type='Separator'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Pm.queryDetailInfo")' :click="buttonClick" operate='detail'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Pm.uploadTask")' :click="buttonClick" operate='upload'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-replenish-data' :tooltipText='$t("Pm.additional")' :click="buttonClick" operate='additional'></e-item>
      </e-items>
    </ejs-toolbar>
    <div class='h-inputBox'>
      <ejs-textbox :placeholder='$t("Pm.taskName")' @keydown.enter.native="taskListSearchClick" v-model='input'></ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolBarForTaskList',
  props: [
    'taskStatus' // 存放任务状态
  ],
  data() {
    return {
      input: ''
    };
  },
  methods: {

    taskListSearchClick() {
      this.$parent.$refs.gridForTaskList.getTaskListOfTaskListFOrNoReal(this.input);
    },

    // 将工具栏的点击事件分发到父级组件的 methodList 方法中
    buttonClick(args) {
      this.$parent.methodList(args.item.operate);
    }
  },
  watch: {
    // 通过监控任务状态，切换工具栏图标的失效状态
    taskStatus(taskStatus) {
      // 0 新增 | 2 激活  3 挂起  4 修改  5 删除 | 7 一致性检查  8 同步下载 | 10 任务详情
      switch (taskStatus) {
        case 0: // 挂起
          this.$refs.toolBarForTask.enableItems([0, 1, 2, 4, 5, 6, 7, 9, 10], true);
          this.$refs.toolBarForTask.enableItems([3, 8], false);
          break;
        case 1: // 激活
          this.$refs.toolBarForTask.enableItems([0, 1, 3, 6, 7, 8, 9, 10], true);
          this.$refs.toolBarForTask.enableItems([2, 4, 5], false);
          break;
        case 2: // 失效
          this.$refs.toolBarForTask.enableItems([0, 1, 5, 10], true);
          this.$refs.toolBarForTask.enableItems([2, 3, 4, 6, 7, 8, 9], false);
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style>

</style>
